import { schema } from 'normalizr';

const alarmsConfig = new schema.Entity('alarmsConfig', {}, { idAttribute: 'id' });
const alarmsConfigSchema = [alarmsConfig];

export default alarmsConfigSchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/alarmsConfigSchema.js